import { APIContext } from "../../types";
import { makePath } from "../../../../api/url";
import { postJSON } from "../../request";

export type BookingApi = ReturnType<typeof createBookingAPIv1>;

export function createBookingAPIv1({ buildURL, fetchRaw }: APIContext) {
  function claimBookingCapability({
    patientId,
    tokenSegment,
  }: {
    patientId: string;
    tokenSegment: string;
  }) {
    const path = makePath([
      "api",
      "v1",
      "patient",
      patientId,
      "booking",
      "token",
      tokenSegment,
      "claim",
    ]);
    const url = buildURL(path);
    const request = postJSON(url, {});

    return fetchRaw(request);
  }

  return {
    claimBookingCapability,
  };
}
